import { Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackbarService } from './snackbar.service';

const CLIPBOARD_MESSAGE_TIMEOUT = 800;

@Injectable()
export class ClipboardService {

    constructor(private readonly clipboard: Clipboard,
        private readonly snackbarService: SnackbarService) {}

    public copy(text: string) {
        if (this.clipboard.copy(text)) {
            this.snackbarService.show({
                message: 'Copié dans le presse-papier',
                type: 'info',
                timeout: CLIPBOARD_MESSAGE_TIMEOUT,
            });
        }
    }
}
